<div class="p-2 flex row justify-between">
    <div></div>
    <div>
        <button mat-dialog-close class="btn btn-xs">
            x
        </button>
    </div>
</div>
<div class="carousel w-full flex items-center justify-center">
  <ng-container *ngFor="let image of images;let i = index">
    <div  *ngIf="current == i" [id]="'slide' + i" class="flex items-center justify-center block carousel-item relative w-full">
        <img
            [src]="image"
            class="rounded-lg block"
            style="max-height: 70vh;width: auto"
        />
        <div
            class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2"
        >
            <a (click)="toSlide('next')" class="btn btn-circle">❮</a>
            <a (click)="toSlide('prev')" class="btn btn-circle">❯</a>
        </div>
    </div>
  </ng-container>
</div>
<div class="flex justify-center w-full py-2 gap-2">
    <a *ngFor="let image of images;let i = index" (click)="toSlide(i)" class="btn btn-xs">{{i + 1}}</a>
</div>
